<template>
  <div class="patient-consent-wrapper">
    <rp-consent class="patient-consent" />
    <rp-button type="primary" @click="onConfirm">Confirm</rp-button>
  </div>
</template>

<script>
  import Button from 'raypro_ui/src/components/ui/inputs/Button'
  import Consent from 'raypro_ui/src/components/ui/ConsentStatement'

  export default {
    components: {
      'rp-button': Button,
      'rp-consent': Consent,
    },

    methods: {
      onConfirm() {
        this.$router.go(-1)
      }
    },
  }
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .patient-consent-wrapper
    padding: 0 30px 20px 30px
    border-radius: 20px
    color: $color-text
    font-family: 'Stolzl'
    font-size: larger
    background-color: $color-panel-bg

    .patient-consent
      .consent
        a
          color: $color-text

    .tab-buttons
      .btn
        width: 170px
        font-size: small
        font-family: 'Stolzl'
        border-color: $color-text
        border-radius: 5px
        color: $color-grey-darker
        &:hover
          text-decoration: underline
        &.selected
          color: $color-text
          font-weight: bold
          text-decoration: none
</style>



// WEBPACK FOOTER //
// src/components/pages/Patients/PatientConsent.vue